module.exports = __webpack_public_path__ + "img/Stemness-CRC_10X_TGSP.e75baa8c.png";